var PES = PES || {};
PES.PasswordStrengthModel = function (passwordId, loginOrRegister) {
    var self = this;
    self.passwordNotEmpty = ko.observable(false);
    self.passwordStrengthMessage = ko.observable("");
    self.displayLoading = ko.observable(true);

    self.jqPassword = $('#' + passwordId);
    self.togglePasswordVisibility = function (model, e) {
        var passwordIsHidden = self.jqPassword.attr("type") == "text";
        if (passwordIsHidden) {
            self.jqPassword.attr("type", "password");
            $(e.target).removeClass('show-pass').addClass('hide-pass');
        } else {
            self.jqPassword.attr("type", "text");
            $(e.target).removeClass('hide-pass').addClass('show-pass');
        }
    };
    self.displayStrengthify = function () {
        var strengthifyWrapper = $('.strengthify-wrapper');
        strengthifyWrapper.show();
        var strength = strengthifyWrapper.find('.strengthify-tiles').text();
        self.passwordStrengthMessage(strength);
    }

    self.registerEventListeners = function () {

        self.jqPassword.strengthify({
            zxcvbn: 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.3.0/zxcvbn.js',
            tilesOptions: {
                tooltip: false,
                element: true
            },
            drawTitles: true,
            drawMessage: false,
            drawBars: true
        });

        self.jqPassword.on('keyup', function (e) {
            var pass = $(e.target).val();
            self.passwordNotEmpty(pass !== '');
            
            if (!loginOrRegister || loginOrRegister.displayRegister()) {
                self.displayStrengthify();
            }
        });
    }

    self.registerEventListeners();
}